import rest from '@modules/rest'
import upload from '@modules/upload'
import { getUploadEndpoint, getFileUrl } from '@modules/fileHelpers'
import { PERSONAL_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import { mapCustomFields, mapSystemFields } from '@convenia/employee-organisms/SystemFields/Personal/content/mappers'
import { mapEducation, mapEducationInput } from '@convenia/employee-organisms/SystemFields/Personal/content/mappers/education'

export const getFormations = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/employee-educations/admission`
    const { data = [] } = await rest.get(url)

    const formations = data.map(({ customFieldValues, ...formation }) => ({
      ...mapEducation(formation, { employeeId, getFileUrl }),
      customFieldValues,
    }))

    return [ null, formations ]
  } catch (err) {
    return [ err, null ]
  }
}

export const createFormation = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/employee-educations/admission`
    const body = mapEducationInput({ data, schema })

    const response = await rest.post(url, { body, headers: { bcv: true } })

    const formation = mapEducation(response.data, { employeeId, getFileUrl })

    return [ null, formation ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateFormation = async (data, params) => {
  try {
    const formationId = data?.id
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/employee-educations/${formationId}/admission`
    const body = mapEducationInput({ data, schema })

    await rest.put(url, { body, headers: { bcv: true } })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const deleteFormation = async (data, params) => {
  try {
    const formationId = data?.id
    const isCreating = typeof formationId !== 'string'

    if (isCreating)
      return [ null, null ]

    const { employeeId, companyId } = params

    await rest.delete(`/employees/proxy/companies/${companyId}/employees/${employeeId}/employee-educations/${formationId}/admission`)

    return [ null, null ]
  } catch (err) {
    return [ err, null ]
  }
}

export const uploadFormationFiles = async ({ id, files, employeeId }) => {
  try {
    const endpoint = getUploadEndpoint(employeeId, id, 'education')

    const data = await upload({ files, endpoint })

    return [ null, data || [] ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getSystemFields = async ({ employeeId, companyId }) => {
  const url = `/companies/proxy/companies/${companyId}/employees/${employeeId}/fields/admission`

  try {
    const { data } = await rest.get(url, { params: { area: PERSONAL_AREA.LABEL } })
    const fields = data?.sections || []

    const systemFields = mapSystemFields(fields)
    const customFields = mapCustomFields(fields)

    return [ null, { systemFields, customFields } ]
  } catch (err) {
    return [ err, null ]
  }
}
